export default {
    props: {
        messagesCommandsCancel: {
            type: String,
            kComposite: 'messages.commands.cancel'
        }, 
        messagesCommandsCanceledit: {
            type: String,
            kComposite: 'messages.commands.canceledit'
        }, 
        messagesCommandsCreate: {
            type: String,
            kComposite: 'messages.commands.create'
        }, 
        messagesCommandsDestroy: {
            type: String,
            kComposite: 'messages.commands.destroy'
        }, 
        messagesCommandsEdit: {
            type: String,
            kComposite: 'messages.commands.edit'
        }, 
        messagesCommandsExcel: {
            type: String,
            kComposite: 'messages.commands.excel'
        }, 
        messagesCommandsSave: {
            type: String,
            kComposite: 'messages.commands.save'
        }, 
        messagesCommandsUpdate: {
            type: String,
            kComposite: 'messages.commands.update'
        }, 
        messagesNoRecords: {
            type: String,
            kComposite: 'messages.noRecords'
        }, 
        messagesExpandCollapseColumnHeader: {
            type: String,
            kComposite: 'messages.expandCollapseColumnHeader'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Messages.js